module.exports = __webpack_public_path__ + "font_uzura.89c51304.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_uzura.png
// module id = TRHO
// module chunks = 0